import { SumberPengadaanApi } from "api";
import { ActionButton, Input, TextArea } from "components";
import { useFormikContext } from "formik";
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";

export const ModalAction = ({ setModalConfig, modalConfig }) => {
  const [isNomorLoading, setIsNomorLoading] = useState(false);
  const {
    values,
    handleChange,
    setValues,
    handleSubmit,
    isSubmitting,
    errors,
    touched,
    resetForm,
  } = useFormikContext();

  const getNomorHandler = () => {
    setIsNomorLoading(true);

    SumberPengadaanApi.getKode()
      .then(({ data }) => {
        const kode = data.data;
        if (modalConfig.type === "add") {
          setValues({
            ...values,
            kodeSumberPengadaan: kode,
          });
        }
      })
      .catch(() => {
        setValues({
          ...values,
          kodeSumberPengadaan: "",
        });
        window.alert("Nomor gagal dimuat");
      })
      .finally(() => {
        setIsNomorLoading(false);
      });
  };

  useEffect(() => {
    getNomorHandler();

    return () => {
      setIsNomorLoading(false);
    };
  }, []);

  return (
    <div>
      <Modal
        show={modalConfig?.show}
        onHide={() => setModalConfig({ data: {}, type: "add", show: false })}
      >
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            {modalConfig.type === "edit" ? "Ubah" : "Tambah"} Sumber Pengadaan
          </Modal.Header>
          <Modal.Body>
            <Input
              label="Kode Sumber Pengadaan"
              placeholder="Masukan kode sumber pengadaan"
              name="kodeSumberPengadaan"
              value={
                isNomorLoading ? "Memuat data ..." : values?.kodeSumberPengadaan
              }
              readOnly
            />
            <Input
              label="Nama Sumber Pengadaan"
              placeholder="Masukan nama sumber pengadaan"
              name="namaSumberPengadaan"
              value={values?.namaSumberPengadaan}
              onChange={handleChange}
              error={
                Boolean(errors.namaSumberPengadaan) &&
                touched.namaSumberPengadaan
              }
              errorText={
                Boolean(errors.namaSumberPengadaan) &&
                touched.namaSumberPengadaan &&
                errors.namaSumberPengadaan
              }
            />
            <TextArea
              label="Keterangan"
              placeholder="Masukan keterangan"
              name="keterangan"
              rows="4"
              value={values?.keterangan}
              onChange={handleChange}
            />
          </Modal.Body>
          <Modal.Footer>
            {/* <ActionButton
              text="Batal"
              variant="outline-secondary"
              size="sm"
              onClick={() =>
                resetForm({
                  values: { namaSumberPengadaan: "", keterangan: "" },
                })
              }
            /> */}
            <ActionButton
              text={modalConfig.type === "edit" ? "Ubah" : "Simpan"}
              type="submit"
              size="sm"
              variant={modalConfig.type === "edit" ? "success" : "primary"}
              loading={isSubmitting}
            />
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
